<template>
    <div id="university">
        <div class="universityTop">
            <div class="searchBox">
                <input type="text" placeholder="搜索院校名称" v-model="name" @keyup.enter="search(1)">
                <div class="search" @click="search(1)"></div>
            </div>
            <ul class="list">
                <li>
                    <span>学校地区 ></span>
                    <ul class="change" id="area">
                        <li v-for="(item ,index) in Provinces"  :class="index==0 && 'changeFirst'">
                            <input type="checkbox" :value="item.value" @change="diquChange($event)">
                            <span>{{item.names}}</span>
                        </li>
                    </ul>
                </li>
                <div class="line"></div>    
                <li>
                    <span>大学类别 ></span>
                    <ul class="change" id="typeYuanxiao">
                        <li v-for="(item ,index) in daxueleibie"  :class=" index == 0 && 'changeFirst'">
                            <input type="checkbox" :value="item.value" @change="typeChange($event)">
                            <span>{{item.names}}</span>
                        </li>
                    </ul>
                </li>          
                <div class="line"></div>
                <li>
                    <span>特色标签 ></span>
                    <ul class="change">
                        <li>
                            <!-- <input type="checkbox" class="texing" value="全部" @click="yuanxiaoChange">
                            <span>全部</span> -->
                            <input type="checkbox" class="texing" value="双一流" @click="yuanxiaoChange">
                            <span>双一流</span>
                            <input type="checkbox" class="texing" value="985" @click="yuanxiaoChange">
                            <span>985</span>
                            <input type="checkbox" class="texing" value="211" @click="yuanxiaoChange">
                            <span>211</span>
                        </li>
                    </ul>
                </li>
                <div class="line"></div>
            </ul>
        </div>
        <ul class="universityBottom" v-if="listShow">
            <li v-for="(item,index) in cdataList">
                <div class="listTop">
                    <div class="logo" >
                        <img :src="item.collegeImage" style="width:80%"/>
                    
                    </div>
                    <div class="content">
                        <p>{{item.collegeName}}
                            <img src="/imgs/xingaokao/mubiaotansuo/yuanxiaoku/area.png" alt="">
                            <span>{{item.provinceName}}</span>
                        </p>
                        <p class="tag">
                            <span v-if="item.is211==1">211</span>
                            <span v-if="item.is985==1">985</span>
                            <span v-if="item.collegeLevel==1">双一流</span>
                        </p>
                    </div>
                    <div class="showMore" @click="showMore(index)">
                        查看学科数据
                    </div>
                </div>
                <div class="tables">
                    <table>
                        <thead>
                        <tr>
                            <td>专业名称/专业类</td>
                            <td>招生层次</td>
                            <td v-if="typeSubject==1">首选科目要求</td>
                            <td v-if="typeSubject==1">再选科目要求</td>
                            <td v-if="typeSubject==2">科目要求</td>
                        </tr>
                        </thead>
                        <tbody>
                        <tr v-for="ite in item.chooseSubject">
                            <td :style="{color: ite.remark ? '#2c8ffc' : ''}">
                                {{ite.majorName}}
                                <div class="descript" v-if="ite.remark">
                                    {{ite.remark.replace(/、/g,"&nbsp;| &nbsp;")}}
                                </div>
                            </td>
                            <td>{{ite.typeName}}</td>
                            <td v-if="typeSubject==2">{{ite.chooseCourseRequire}}</td>
                            <td v-if="typeSubject==1">{{ite.firstCourseRequire}}</td>
                            <td v-if="typeSubject==1">{{ite.secondCourseRequire}}</td>
                        </tr>
                        </tbody>
                    </table>
                </div>
            </li>
        </ul>
        <div class="searchNull" v-show="searchNull">没有满足条件的结果，换一个试试？</div>
        <div class="operation">
            <div class="more" @click="search(pageNumber)">↓查看更多</div>
            <div class="return" @click="back">↑返回顶部</div>
        </div>
        <div class="loading" v-if="loading">
            <loading></loading>
        </div>
    </div>
</template>
<script>
    import Loading from '../../../components/Loading2.vue'
    export default {
        name: "university",
        components:{Loading},
        data(){
            return{
                // 地区
                Provinces:[
                    { names: '全部', value: '全部' },
                    { names: '北京', value: '110000' },
                    { names: '天津', value: '120000' },
                    { names: '上海', value: '310000' },
                    { names: '重庆', value: '500000' },
                    { names: '河北', value: '130000' },
                    { names: '河南', value: '410000' },
                    { names: '云南', value: '530000' },
                    { names: '辽宁', value: '210000' },
                    { names: '黑龙江', value: '230000' },
                    { names: '湖南', value: '430000' },
                    { names: '安徽', value: '340000' },
                    { names: '山东', value: '370000' },
                    { names: '新疆', value: '650000' },
                    { names: '江苏', value: '320000' },
                    { names: '浙江', value: '330000' },
                    { names: '江西', value: '360000' },
                    { names: '湖北', value: '420000' },
                    { names: '广西', value: '450000' },
                    { names: '甘肃', value: '620000' },
                    { names: '山西', value: '140000' },
                    { names: '陕西', value: '610000' },
                    { names: '吉林', value: '220000' },
                    { names: '福建', value: '350000' },
                    { names: '贵州', value: '520000' },
                    { names: '内蒙古', value: '150000' },
                    { names: '广东', value: '440000' },
                    { names: '青海', value: '630000' },
                    { names: '西藏', value: '540000' },
                    { names: '四川', value: '510000' },
                    { names: '宁夏', value: '640000' },
                    { names: '海南', value: '460000' }
                ],
                // 大学类别
                daxueleibie: [
                    { names: '全部院校',  value: '全部' },
                    { names: '语言类院校', value: '1' },
                    { names: '医药类院校', value: '2' },
                    { names: '政法类院校', value: '3' },
                    { names: '综合类院校', value: '4' },
                    { names: '艺术类院校', value: '5' },
                    { names: '体育类院校', value: '6' },
                    { names: '林业类院校', value: '7' },
                    { names: '理工类院校', value: '8' },
                    { names: '农林类院校', value: '9' },
                    { names: '师范类院校', value: '10' },                
                    { names: '财经类院校', value: '11' },
                    { names: '民族类院校', value: '12' },                  
                    // { names: '军事类', value: '军事类' }
                ],
                city:'',
                lastPage:false,
                listShow:false,
                searchNull:false,
                cdataList:[],
                type:[],//院校分类
                name:"",//院校名称
                belongProvince:[],//院校省份
                tag985:0,  //院校特性 ： 985
                tag211:0,  //院校特性 ： 211
                tagZhongdianxueke:'', //重点学科
                tagTesezhuanye:'',  //特色专业
                tagBushenghejian:'', //部省合建
                tagShuangyiliu:'',//院校特性 ：1.一流大学A类 2.一流大学B类 3.一流学科
                tagBaoyanzige:'', //保研资格
                tagZizhuzhaosheng:'', //自主招生
                tagZonghepingjia:'', //综合评价
                tagZhuanxiangjihua:'',//专项计划
                pageNumber:1,//第几页
                pageSize:'' ,//每页条数
                loading:false,
                number:0,
                typeSubject:null,
            }
        },
        created(){
            this.Provinces.map((item)=>{
                if(item.names == this.$store.state.user.province){
                    this.city = item.names;
                }
            })           
            //判断身份选科类型
            if([
                '北京',
                '海南',
                '山东',
                '上海',
                '天津',
                '浙江',               
                ].indexOf(this.city) == -1){
                this.typeSubject = 1
            }else{
                
                this.typeSubject = 2
            }
        },
        methods:{
            //院校类别
            typeChange(e,index){
                this.pageNumber=1
                this.type=[]
                if(e.target.value == '全部' && e.target.checked){
                    $('#typeYuanxiao').find('input').prop('checked',true);
                }else if(e.target.value == '全部' && !e.target.checked){
                    $('#typeYuanxiao').find('input').prop('checked',false);
                }else{
                    $(e.target).parent().parent().find('.changeFirst').find('input').prop('checked',false)
                }
                if($('#typeYuanxiao .changeFirst').siblings().find('input:checked').length == 12){
                    $('#typeYuanxiao .changeFirst').find('input').prop('checked',true);
                }else{
                    $('#typeYuanxiao').find('input:checked').each(function (i,n) {
                        this.type.push(n.value)
                    }.bind(this))
                }
                this.search(1)
            },


            //地区
            diquChange(e){
                this.pageNumber=1
                this.belongProvince=[];
                if(e.target.value=='全部'&&e.target.checked){
                    $('#area').find('input').prop('checked',true);
                }else if(e.target.value=='全部'&&!e.target.checked){
                    $('#area').find('input').prop('checked',false);
                }else{
                    $(e.target).parent().parent().find('.changeFirst').find('input').prop('checked',false)
                }
                if($('#area .changeFirst').siblings().find('input:checked').length == 31){
                    $('#area .changeFirst').find('input').prop('checked',true)
                }else{
                    $('#area').find('input:checked').each(function (i,n) {
                        this.belongProvince.push(n.value)
                    }.bind(this))
                }
                this.search(1)
            },
            //搜索
            search(number){
                this.searchNull=false;
                if(number == 1){
                    this.pageNumber=1;
                    this.lastPage=false;
                    this.cdataList=[];
                    $('.more').css({background: '',boxShadow:''})
                }
                if(this.type.length == 13){
                    console.log('13');
                    this.type = [];
                }
                if(!this.lastPage) {
                    this.loading=true;
                    this.$ajax.post(this.G_uri + '/chooseSubject/getInstitutionSubjectRequireList', {
                        collegename: this.name,
                        provinceID: this.belongProvince,
                        type: this.type,
                        collegeLevel:this.tagShuangyiliu,
                        is985:this.tag985,
                        is211:this.tag211,
                        pageNumber: number,
                        pageSize: 10
                    }, {
                        headers: {
                            token: window.sessionStorage.getItem('ymtxToken')
                        }
                    }).then(function (data) {
                        console.log(data)
                        this.listShow = true;
                        if(data.data.data.page.totalPage==0){
                            this.searchNull=true;
                        }
                        if (data.data.data.page.totalPage <= this.pageNumber) {
                            this.lastPage = true;
                            $('.more').css({background: '#d9d9d9',boxShadow:'0 2px 1px #8f8d8d'})
                        }
                        $(data.data.data.list).each(function (i, item) {
                                this.cdataList[this.cdataList.length]=item
                        }.bind(this))
                        if (number == 1) {
                            this.pageNumber = 2;
                            this.$nextTick(function () {
                                $('.tables').eq(0).show()
                            })
                            setTimeout(function () {
                                $('.tables').eq(0).show()
                            },0)
                        } else {
                            this.pageNumber++;
                        }
                        this.loading = false
                    }.bind(this))
                }
            },
            //院校特性
            yuanxiaoChange(e){
                this.tagShuangyiliu = '';
                this.tag985 = 0;
                this.tag211 = 0;
                $(e.target).parent().find("input:checked").each(function (i,item) {
                    if(item.value == '双一流'){
                        this.tagShuangyiliu = 9;
                    }
                    if(item.value=='985'){
                        this.tag985 = 1
                    }
                    if(item.value=='211'){
                        this.tag211 = 1 
                    }
                    // if(item.value=='全部'){
                    //     this.tagShuangyiliu = 9;
                    //     this.tag985 = 1;
                    //     this.tag211 = 1 ;
                    // }
                }.bind(this))
                this.search(1)
            },
            //返回顶部
            back(){
                window.scrollTo(0, 0)
            },
            //查看学科数据
            showMore(index){
              if($('.tables').eq(index)[0].style.display == 'block'){
                  $('.tables').eq(index).hide()
              }else{
                  $('.tables').hide();
                  $('.tables').eq(index).show()
              }
            }
        },
        mounted(){
            let data = JSON.parse(sessionStorage.getItem('userData'))||{}          
            $("#area input").each(function(i,item){              
                if(item.value == data.provinceId){
                    $(item).prop('checked',true)
                    this.belongProvince = [data.provinceId ]
                    this.search(1)
                }
            }.bind(this))
        },
    }
</script>
<style scoped>
    .universityTop{
        /*background:#fff;*/
        /*border:1px solid #E3E6EB;*/
        box-sizing:border-box;
        padding:13px 0;
    }
    .title{
        width: 190px;
        height: 40px;
        background:url(/imgs/xingaokao/xuankejuece/xuekezhixuan/icon_biaoti.png);
        background-repeat:no-repeat;
        background-position-x: -13px;
        text-align: center;
        line-height: 40px;
        font-size: 14px;
        letter-spacing: 0.1em;
        font-weight: bolder;
        color:#fff;
        position: relative;
        left:-2px;
    }
    .searchBox{
        height: 40px;
        border-radius: 5px;
        position: relative;
        width: 520px;
        margin: 0 auto 35px;
    }
    .searchBox>input{
            height: 44px;
            border: 1px solid #2c8ffc;
            width: 100%;
            padding-left: 20px;
            font-size: 14px;
            line-height: 42px;
            border-radius: 27px;
            -webkit-box-sizing: border-box;
            box-sizing: border-box;
    }
    .search{
            background: url(/imgs/elective/common/icon_sousuo.png) no-repeat center center;
            width: 40px;
            height: 44px;
            font-size: 14px;
            line-height: 44px;
            text-align: center;
            color: #fff;
            cursor: pointer;
            position: absolute;
            right: 10px;
            top: 0;
            overflow: hidden;
    }
    .list{
        box-sizing: border-box;
        width: 100%;
        padding: 10px 18px;
        overflow: hidden;
    }
    .list>li>span{
        color:#323232;
        font-size: 14px;
        font-weight: bolder;
        line-height: 24px;
        display: inline-block;
        margin-right: 20px;
    }
    .list>li{
        overflow: hidden;
    }
    .line{
        width: 100%;
        height: 1px;
        background: #F2F2F2;
        margin: 10px 0;
    }
    .change{
        display: inline-block;
        line-height: 30px;
        width: 840px;
        float: right;
    }
    .change>li{
        display: inline-block;
    }
    .change>li>input{
        width: 16px;
        height: 16px;
        cursor: pointer;
    }
    .change>li>span{
        font-size: 14px;
        position: relative;
        margin-left:9px;
        margin-right: 18px;
        top:-2px;
    }
    /*#typeYuanxiao>li{*/
    /*width: 50px;*/
    /*height: 24px;*/
    /*text-align: center;*/
    /*line-height: 24px;*/
    /*font-size: 14px;*/
    /*color:#666666;*/
    /*cursor: pointer;*/
    /*margin-right: 18px;*/
    /*}*/
    .universityBottom{
        margin-top: 13px;
        padding: 0 24px;
        box-sizing: border-box;
        background: white;
    }
    .universityBottom>li{
        padding: 20px;
        border-radius: 5px;
    }
    .universityBottom>li:first-child{
        box-shadow: 0px 0px 21px rgba(218, 218, 218,.6);
        z-index: 2;
    }
    .universityBottom>li:hover{
        box-shadow: 0px 0px 21px rgba(218, 218, 218,.6);
        z-index: 2;
    }
    .listTop{
        width: 100%;
        height: 100px;
        border-bottom:1px solid #F2F2F2;
        position: relative;
    }
    .logo{
        width: 100px;
        height: 100px;
        float: left;
        margin-right: 15px;
        background-position: center center;
        background-repeat: no-repeat;
        background-size: 66%;
    }
    .content{
        padding-top: 20px;
        box-sizing: border-box;
    }
    .content>p>img{
        width: 12px;
        height: 15px;
    }
    .content>p{
        font-size: 20px;
        letter-spacing: 0.1em;
        color:#323232;
        font-weight: bolder;
    }
    .content>p>span{
        font-size:12px;
        color:#A1A3AF;
        font-weight: normal;
    }
    .tag{
        margin-top: 15px;
    }
    .tag>span{
        height: 25px;
        display: block;
        float: left;
        padding: 0 8px;
        background: #E0EDFF;
        color:#5383B4 !important;
        font-size:13px;
        margin-right: 14px;
        line-height: 25px;
    }
    .showMore{
        width: 110px;
        height: 32px;
        text-align: center;
        float: right;
        line-height: 32px;
        position: absolute;
        top:34px;
        right: 0;
        background:#2B90FC;
        color:#F5F7F4;
        font-size: 13px;
        letter-spacing: 0.05em;
        cursor: pointer;
        box-shadow: 0 2px 1px #1670D1;
    }
    .searchNull{
        text-align: center;
        font-size: 18px;
        padding-top: 20px;
        color:#666;
        letter-spacing: 0.1em;
    }
    .operation{
        margin: 40px 0;
        position: relative;
        height: 33px;
    }
    .more{
        width: 120px;
        height: 33px;
        line-height: 33px;
        text-align: center;
        background: #2D8FFC;
        color:#FEFDFB;
        letter-spacing: 0.15em;
        cursor: pointer;
        border-radius: 3px;
        margin: 0 auto;
        box-shadow: 0 2px 1px #1670D1;
    }
    .return{
        width: 120px;
        height: 33px;
        line-height: 33px;
        text-align: center;
        background: #2D8FFC;
        color:#FEFDFB;
        letter-spacing: 0.15em;
        cursor: pointer;
        border-radius: 3px;
        position: absolute;
        right:40px;
        top: 0;
        box-shadow: 0 2px 1px #1670D1;
        margin-bottom: 30px;
    }
    td{
        border:1px solid #F2F2F2;
        text-align: center;
        line-height: 48px;
        font-size: 14px;
        letter-spacing: 0.1em;
    }
    thead td{
        font-size: 15px;
        color:#323232;
        font-weight: bolder;
        background:#E3E7F2;
    }
    table{
        border:1px solid #F2F2F2;
        background: #FAFAFA;
        margin-top:12px;
    }
    .tables{
        max-height: 248px;
        display: none;
        overflow-x: hidden;
    }
    tbody>tr>td:first-child{
        cursor: pointer;
        position: relative;
    }
    .descript{
        position: absolute;
        left:65%;
        top: 0;
        background: #fff;
        width: 400px;
        box-sizing: border-box;
        box-shadow: 0 0 0 1px #EBEBEB;
        border-radius: 2px;
        padding: 0 18px;
        line-height: 28px;
        color:#333333;
        text-align: left;
        display: none;
    }
    .descript:after{
        content: "";
        display: block;
        width: 15px;
        height: 20px;
        position: absolute;
        left:-11px;
        top: 5px;
        background-image:url(/imgs/xingaokao/xuankejuece/xuekezhixuan/three.png);
        background-size: 100% 100%;
    }
    td:hover .descript{
        display: block;
    }
    .loading{
        height: 120px;
    }
    input[type='checkbox']{
        /*-webkit-appearance:none;*/
        background-image:url(/imgs/xingaokao/xuankejuece/xuekezhixuan/checked1.png);
        background-size: 100% 100%;
    }
    input[type='checkbox']:checked{
        background-image:url(/imgs/xingaokao/xuankejuece/xuekezhixuan/checked2.png);
        background-size: 100% 100%;
    }
    .jinzhi{
        background: #d9d9d9;
        box-shadow:0 2px 1px #8f8d8d;
    }
</style>
